import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VeiculoEmSeuNome } from '../../model/veiculo';

@Component({
  selector: 'app-ficha-cadastro-veiculo-proprio-card',
  templateUrl: './ficha-cadastro-veiculo-proprio-card.component.html',
  styleUrls: ['./ficha-cadastro-veiculo-proprio-card.component.scss'],
})
export class FichaCadastroVeiculoProprioCardComponent implements OnInit {
  @Input() index: number;
  @Input() veiculo: VeiculoEmSeuNome;
  @Input() veiculos: VeiculoEmSeuNome[];
  @Input() showButtonClose: boolean;
  @Output() remover: EventEmitter<void> = new EventEmitter();
  @Output() editar: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public onClickRemove(): void {
    this.remover.emit();
  }

  public onClickEdit(): void {
    this.editar.emit();
  }

  public get hasPlaca():boolean {
    return !!this.veiculo.veiculoPlaca;
  }

  public get descricao(): string {
    const {
      veiculoMarca,
      veiculoModelo,
      veiculoVersao,
      veiculoAno,
    } = this.veiculo;

    return `${(veiculoMarca && veiculoMarca.descricao) || ''} ${
      (veiculoModelo && veiculoModelo.descricao) || ''
    } ${
      (veiculoVersao && veiculoVersao.descricao) || ''
    } ${veiculoAno}`;
  }

  public get hasAnyEdit(): boolean {
    return this.veiculos.some(v => v.isEdit);
  }

  public get title(): string {
    return `Informações do Caminhão Próprio ${this.index + 1}`;
  }
}
